/* EG Collections — Config (collection filter rules) */

window.EG_COLLECTION_FILTERS = {
default: {
  allow: [
    "filter.p.vendor",
    "filter.v.availability",
    "filter.v.price",
    "filter.p.m.delivery.delivery",
    "filter.p.product_type"
  ],
  order: [
    "filter.v.availability",
    "filter.v.price",
    "filter.p.m.delivery.delivery",
    "filter.p.vendor",
    "filter.p.product_type"
  ]
},

templates: {
  brand: {
    allow: [
      "filter.v.price",
      "filter.v.availability",
      "filter.p.m.delivery.delivery",
      "filter.p.product_type"
    ],
    order: [
      "filter.v.availability",
      "filter.v.price",
      "filter.p.m.delivery.delivery",
      "filter.p.product_type"
    ]
  },

  "fancy-brand": {
    allow: [
      "filter.v.availability",
      "filter.v.price",
      "filter.p.m.delivery.delivery",
      "filter.p.product_type"
    ],
    order: [
      "filter.v.availability",
      "filter.v.price",
      "filter.p.m.delivery.delivery",
      "filter.p.product_type"
    ]
  }
},

collections: {
    "test-collection": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.dimensions", "tagset.performance", "tagset.base_build", "tagset.style", "tag.game-type"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "length",           label: "Length (mm)",    mode: "multi",  match: { startsWith: "Length_" } },
      { key: "width",            label: "Width (mm)",     mode: "multi",  match: { startsWith: "Width_" } },
      { key: "thickness",        label: "Thickness (mm)", mode: "multi",  match: { startsWith: "Thickness_" } },
      { key: "area",             label: "Area (cm²)",     mode: "multi",  match: { startsWith: "Area_" } },
      { key: "surface_material", label: "Surface",        mode: "multi",  match: { startsWith: "Surface Material_" } },
      { key: "surface_texture",  label: "Texture",        mode: "multi",  match: { startsWith: "Surface Texture__" } },
      { key: "surface_type",     label: "Glide Type",     mode: "multi",  match: { startsWith: "Surface Type__" } },
      { key: "surface-coating",  label: "Coating",        mode: "multi",  match: { startsWith: "Surface Coating__" } },
      { key: "firmness",         label: "Firmness",       mode: "multi",  match: { startsWith: "Firmness__" } },
      { key: "base-material",    label: "Base",           mode: "multi",  match: { startsWith: "Base Material__" } },
      { key: "stitched-edges",   label: "Stitched Edges", mode: "single", match: { startsWith: "Stitched Edges_" } },
      { key: "washable",         label: "Washable",       mode: "multi",  match: { startsWith: "Washable__" } },
      { key: "packaging-type",   label: "Packaging",      mode: "single", match: { startsWith: "Packaging Type__" } },
      { key: "colour",           label: "Colour",         mode: "multi",  match: { startsWith: "F-Color_" } },
      { key: "lighting",         label: "Lighting",       mode: "single", match: { startsWith: "Lighting_" } },
      { key: "graphics",         label: "Graphics",       mode: "single", match: { startsWith: "Graphics__" } },
      { key: "game-type",        label: "Game Type",      mode: "multi",  match: { startsWith: "Game Type_" } },
      { key: "nav-size",         label: "Size",           mode: "multi", match: { startsWith: "Size_" } }
    ],

    tagGroupSets: [
      {
        key: "dimensions",
        label: "Dimensions",
        children: ["length", "width", "thickness", "area"]
      },
      {
        key: "performance",
        label: "Performance",
        children: ["surface_type", "surface_material", "surface_texture", "surface-coating", "firmness"]
      },
      {
        key: "base_build",
        label: "Base & Build",
        children: ["base-material", "stitched-edges", "washable", "packaging-type"]
      },
      {
        key: "style",
        label: "Style",
        children: ["colour", "graphics", "lighting"]
      }
    ],

      valueOrder: {
        "tag.firmness": ["Extra Soft", "Soft", "Mid", "Hard"],
        "tag.surface_texture": ["Ultra Smooth", "Very Smooth", "Smooth", "Slightly Textured", "Slightly Grainy", "Grainy", "Textured", "Honey Comb", "Slightly Rough", "Rough"],
        "tag.stitched-edges": ["Yes", "No"],
        "tag.washable": ["Yes","Yes (Wipe Clean)", "No"],
        "tag.graphics": ["Yes", "No"],
        "tag.lighting": ["Yes", "No"]
      }
  },
  "gaming-mousepads": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.dimensions", "tagset.performance", "tagset.base_build", "tagset.style", "tag.game-type"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "length",           label: "Length (mm)",    mode: "multi",  match: { startsWith: "Length_" } },
      { key: "width",            label: "Width (mm)",     mode: "multi",  match: { startsWith: "Width_" } },
      { key: "thickness",        label: "Thickness (mm)", mode: "multi",  match: { startsWith: "Thickness_" } },
      { key: "area",             label: "Area (cm²)",     mode: "multi",  match: { startsWith: "Area_" } },
      { key: "surface_material", label: "Surface",        mode: "multi",  match: { startsWith: "Surface Material_" } },
      { key: "surface_texture",  label: "Texture",        mode: "multi",  match: { startsWith: "Surface Texture__" } },
      { key: "surface_type",     label: "Glide Type",     mode: "multi",  match: { startsWith: "Surface Type__" } },
      { key: "surface-coating",  label: "Coating",        mode: "multi",  match: { startsWith: "Surface Coating__" } },
      { key: "firmness",         label: "Firmness",       mode: "multi",  match: { startsWith: "Firmness__" } },
      { key: "base-material",    label: "Base",           mode: "multi",  match: { startsWith: "Base Material__" } },
      { key: "stitched-edges",   label: "Stitched Edges", mode: "single", match: { startsWith: "Stitched Edges_" } },
      { key: "washable",         label: "Washable",       mode: "multi",  match: { startsWith: "Washable__" } },
      { key: "packaging-type",   label: "Packaging",      mode: "single", match: { startsWith: "Packaging Type__" } },
      { key: "colour",           label: "Colour",         mode: "multi",  match: { startsWith: "F-Color_" } },
      { key: "lighting",         label: "Lighting",       mode: "single", match: { startsWith: "Lighting_" } },
      { key: "graphics",         label: "Graphics",       mode: "single", match: { startsWith: "Graphics__" } },
      { key: "game-type",        label: "Game Type",      mode: "multi",  match: { startsWith: "Game Type_" } },
      { key: "nav-size",         label: "Size",           mode: "multi", match: { startsWith: "Size_" } }
    ],

    tagGroupSets: [
      {
        key: "dimensions",
        label: "Dimensions",
        children: ["length", "width", "thickness", "area"]
      },
      {
        key: "performance",
        label: "Performance",
        children: ["surface_type", "surface_material", "surface_texture", "surface-coating", "firmness"]
      },
      {
        key: "base_build",
        label: "Base & Build",
        children: ["base-material", "stitched-edges", "washable", "packaging-type"]
      },
      {
        key: "style",
        label: "Style",
        children: ["colour", "graphics", "lighting"]
      }
    ],

      valueOrder: {
        "tag.firmness": ["Extra Soft", "Soft", "Mid", "Hard"],
        "tag.surface_texture": ["Ultra Smooth", "Very Smooth", "Smooth", "Slightly Textured", "Slightly Grainy", "Grainy", "Textured", "Honey Comb", "Slightly Rough", "Rough"],
        "tag.stitched-edges": ["Yes", "No"],
        "tag.washable": ["Yes","Yes (Wipe Clean)", "No"],
        "tag.graphics": ["Yes", "No"],
        "tag.lighting": ["Yes", "No"]
      }
  },
  "mice-skates": {
    allow: ["tag.dots", "filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.compatibility", "tagset.build", "tag.glide", "tag.colour" ],
    order: ["tag.dots", "filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "dots",           label: "Dots & Donuts",      mode: "single", ui: "toggle", match: { onlyTags: ["Compatible with_Universal"] } },
      { key: "material",       label: "Material",           mode: "multi",  match: { startsWith: "Material__" } },
      { key: "glide",          label: "Glide",              mode: "multi",  match: { startsWith: "Glide__" } },
      { key: "thickness",      label: "Thickness (mm)",     mode: "multi",  match: { startsWith: "Thickness_" } },
      { key: "surface_comp",   label: "Surface",            mode: "multi",  match: { startsWith: "Surface Compatibility_", excludeStartsWith: ["Surface Compatibility__"] } },
      { key: "comp_with",      label: "Model",              mode: "multi",  match: { startsWith: "Compatible with_", excludeStartsWith: ["Compatible with__"] } },
      { key: "comp_brand",     label: "Brand",              mode: "multi",  match: { startsWith: "Compatible brand_" } },
      { key: "colour",         label: "Colour",             mode: "multi",  match: { startsWith: "Colour_", excludeStartsWith: ["Colour__"] } },
      { key: "rounded_edges",  label: "Rounded Edges",      mode: "single", match: { startsWith: "Rounded Edges__" } }
    ],

    tagGroupSets: [
      {
        key: "compatibility",
        label: "Compatibility",
        children: ["surface_comp", "comp_with"]
      },
      {
        key: "build",
        label: "Build",
        children: ["material", "thickness", "rounded_edges"]
      }
    ],
     valueOrder: {
        "tag.rounded_edges": ["Yes", "No"],
        "tag.lighting": ["Yes", "No"]
      }
  },
    "grip-tape": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.build", "tagset.compatibility", "tag.colour" ],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "material",       label: "Material",       mode: "multi",  match: { startsWith: "Material__" } },
      { key: "thickness",      label: "Thickness (mm)", mode: "multi",  match: { startsWith: "Thickness_" } },
      { key: "comp_with",      label: "Model",          mode: "multi",  match: { startsWith: "Compatible with_", excludeStartsWith: ["Compatible with__"] } },
      { key: "comp_brand",     label: "Brand",          mode: "multi",  match: { startsWith: "Compatible brand_" } },
      { key: "colour",         label: "Colour",         mode: "multi",  match: { startsWith: "Colour_", excludeStartsWith: ["Colour__"] } },
      { key: "flatten_edges",  label: "Flatten Edges",  mode: "single", match: { startsWith: "Flatten Edges__" } }
    ],

    tagGroupSets: [
      {
        key: "build",
        label: "Build",
        children: ["material", "thickness", "flatten_edges"]
      },
      {
        key: "compatibility",
        label: "Compatibility",
        children: ["comp_with"]
      }
    ],
     valueOrder: {
        "tag.flatten_edges": ["Yes", "No"]
      }
  },
      "controller-grip-tape": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.build", "tag.colour" ],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "material",       label: "Material",       mode: "multi",  match: { startsWith: "Material__" } },
      { key: "thickness",      label: "Thickness (mm)", mode: "multi",  match: { startsWith: "Thickness_" } },
      { key: "comp_with",      label: "Model",          mode: "multi",  match: { startsWith: "Compatible with_", excludeStartsWith: ["Compatible with__"] } },
      { key: "comp_brand",     label: "Brand",          mode: "multi",  match: { startsWith: "Compatible brand_" } },
      { key: "colour",         label: "Colour",         mode: "multi",  match: { startsWith: "Colour_", excludeStartsWith: ["Colour__"] } },
      { key: "flatten_edges",  label: "Flatten Edges",  mode: "single", match: { startsWith: "Flatten Edges__" } }
    ],

    tagGroupSets: [
      {
        key: "build",
        label: "Build",
        children: ["material", "thickness", "flatten_edges"]
      }
    ],
     valueOrder: {
        "tag.flatten_edges": ["Yes", "No"]
      }
  },
  "arm-sleeves": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tag.material", "tagset.size", "tagset.style"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "material",       label: "Material",            mode: "multi",  match: { startsWith: "Material_" } },
      { key: "size",           label: "Size",                mode: "multi",  match: { startsWith: "Size_" } },
      { key: "style",          label: "Style",               mode: "multi",  match: { startsWith: "Style_" } },
      { key: "sleeve-length",  label: "Sleeve Length (cm)",  mode: "multi",  match: { startsWith: "Sleeve-Length__" } },
      { key: "colour",         label: "Colour",              mode: "multi",  match: { startsWith: "F-Color_" } }
    ],

    tagGroupSets: [
      {
        key: "size",
        label: "Size",
        children: ["size", "sleeve-length"]
      },
      {
        key: "style",
        label: "Style",
        children: ["style", "colour"]
      }
    ],
     valueOrder: {
        "tag.size": ["S", "M", "L", "XL"]
      }
  },
    "dongles": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.compatibility", "tag.polling-rate","tag.connection", "tag.colour"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "polling-rate",       label: "Polling Rate",   mode: "multi",  match: { startsWith: "Polling Rate__" } },
      { key: "connection",         label: "Connection",     mode: "multi",  match: { startsWith: "Connection__" } },
      { key: "comp_with",          label: "Model",          mode: "multi",  match: { startsWith: "Compatible with_", excludeStartsWith: ["Compatible with__"] } },
      { key: "comp_brand",         label: "Brand",          mode: "multi",  match: { startsWith: "Compatible brand_" } },
      { key: "colour",             label: "Colour",         mode: "multi",  match: { startsWith: "Colour__" } }
    ],

        tagGroupSets: [
      {
        key: "compatibility",
        label: "Compatibility",
        children: ["comp_brand", "comp_with"]
      }
    ]
    },
    "bungees": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tag.comp_with", "tag.base", "tag.colour"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "colour",             label: "Accent Colour",  mode: "multi",  match: { startsWith: "Accent Colour__" } },
      { key: "comp_with",          label: "Compatibility",  mode: "multi",  match: { startsWith: "Compatible with__" } },
      { key: "base",               label: "Base Material",  mode: "multi",  match: { startsWith: "Base Material__" } }
    ]
  },
    "gaming-mice-used-by-pros": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.size", "tagset.design", "tagset.sensor", "tagset.buttons", "tagset.connectivity"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "length",         label: "Length (mm)",          mode: "multi",  match: { startsWith: "Length_" } },
      { key: "width",          label: "Width (mm)",           mode: "multi",  match: { startsWith: "Width_" } },
      { key: "height",         label: "Height (mm)",          mode: "multi",  match: { startsWith: "Height_" } },
      { key: "shape",          label: "Shape",                mode: "multi",  match: { startsWith: "Shape_" } },
      { key: "wired-wireless", label: "Wired/Wireless",       mode: "single", match: { startsWith: "Wired/Wireless_" } },
      { key: "weight",         label: "Weight (g)",           mode: "multi",  match: { startsWith: "P-Weight__" } },
      { key: "switches",       label: "Switches",             mode: "multi",  match: { startsWith: "Switch Type_" } },
      { key: "size",           label: "Size",                 mode: "multi",  match: { startsWith: "Size_" } },
      { key: "shell",          label: "Shell",                mode: "single", match: { startsWith: "Shell__" } },
      { key: "sensor-model",   label: "Model",                mode: "multi",  match: { startsWith: "Sensor Model_" } },
      { key: "polling-rate",   label: "Polling Rate",         mode: "multi",  match: { startsWith: "Polling Rate__" } },
      { key: "grip-style",     label: "Grip Style",           mode: "multi",  match: { startsWith: "Grip Style_" } },
      { key: "buttons",        label: "No. of Buttons",       mode: "multi",  match: { startsWith: "P-Buttons__" } },
    //{ key: "sensor-type",    label: "Type",                 mode: "multi",  match: { startsWith: "Sensor Type_" } },
      { key: "colour",         label: "Colour",               mode: "multi",  match: { startsWith: "F-Color_" } },
      { key: "connection",     label: "Connection",           mode: "multi",  match: { startsWith: "F-Connection_" } },
      { key: "cable-material", label: "Cable Material",       mode: "multi",  match: { startsWith: "Cable Material__" } },
      { key: "cable-length",   label: "Cable Length (m)",     mode: "multi",  match: { startsWith: "Cable Length__" } },
      { key: "battery-life",   label: "Battery Life (Hrs)",   mode: "multi",  match: { startsWith: "F-Battery Life_", excludeStartsWith: ["Battery Life__"] } },
   // { key: "adjustable-dpi", label: "Adjustable DPI",       mode: "multi",  match: { startsWith: "Adjustable DPI__" } },
      { key: "cpi-dpi",        label: "CPI/DPI",              mode: "multi",  match: { startsWith: "CPI/DPI__" } }
    ],

    tagGroupSets: [
      {
        key: "size",
        label: "Size",
        children: ["size", "length", "width", "height"]
      },
      {
        key: "design",
        label: "Design",
        children: ["shape", "grip-style",  "weight", "shell", "colour"]
      },
      {
        key: "sensor",
        label: "Sensor",
        children: ["sensor-type", "sensor-model", "cpi-dpi", "adjustable-dpi"]
      },
      {
        key: "buttons",
        label: "Buttons",
        children: ["buttons", "switches"]
      },
      {
        key: "connectivity",
        label: "Connectivity",
        children: ["wired-wireless", "polling-rate", "battery-life", "connection", "cable-material", "cable-length"]
      },
    ],
        valueOrder: {
        "tag.size": ["S", "M", "L"],
        "tag.grip-style": ["Claw", "Palm", "Fingertip"],
        "tag.shell": ["Solid", "Holes"],
        "tag.polling-rate": ["8000Hz", "4000Hz", "1000Hz"]
      }
  },
    "gaming-keyboards": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.layout", "tagset.design", "tagset.switches", "tagset.keys", "tagset.connectivity"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "length",          label: "Length (mm)",       mode: "multi",  match: { startsWith: "Length_" } },
      { key: "width",           label: "Width (mm)",        mode: "multi",  match: { startsWith: "Width_" } },
      { key: "height",          label: "Height (mm)",       mode: "multi",  match: { startsWith: "Height_" } },
      { key: "wrist-rest",      label: "Wrist Rest",        mode: "single", match: { startsWith: "Wrist Rest_" } },
      { key: "wired-wireless",  label: "Wired/Wireless",    mode: "single", match: { startsWith: "Wired/Wireless_" } },
      { key: "usb-hub",         label: "USB Passthrough",   mode: "single", match: { startsWith: "USB Hub__" } },
      { key: "weight",          label: "Weight (g)",        mode: "multi",  match: { startsWith: "P-Weight__" } },
      { key: "switch-type",     label: "Switch Style",      mode: "multi",  match: { startsWith: "Key Switches_" } },
      { key: "switches",        label: "Switches",          mode: "multi",  match: { startsWith: "P-Keys__" } },
      { key: "media-keys",      label: "Media Keys",        mode: "multi",  match: { startsWith: "Media Keys__" } },
      { key: "macro-keys",      label: "Macro Keys",        mode: "multi",  match: { startsWith: "F-Macro Keys_", excludeStartsWith: ["Macro Keys__"] } },
      { key: "layout",          label: "Layout",            mode: "multi",  match: { startsWith: "Layout_" } },
      { key: "keycaps",         label: "Keycaps",           mode: "multi",  match: { startsWith: "Keycaps__" } },
      { key: "key-rollover",    label: "Key Rollover",      mode: "multi",  match: { startsWith: "Key Rollover__" } },
      { key: "colour",          label: "Colour",            mode: "multi",  match: { startsWith: "F-Color_" } },
      { key: "connection",      label: "Connection",        mode: "multi",  match: { startsWith: "F-Connection_", excludeStartsWith: "Connection__" } },
      { key: "compatibility",   label: "Compatibility",     mode: "multi",  match: { startsWith: "F-Compatibility_", excludeStartsWith: "Compatibility__" } },
      { key: "cable-material",  label: "Cable Material",    mode: "multi",  match: { startsWith: "Cable Material__" } },
      { key: "cable-length",    label: "Cable Length (m)",  mode: "multi",  match: { startsWith: "Cable Length__" } },
      { key: "backlit",         label: "Backlit",           mode: "multi",  match: { startsWith: "Backlit Keys_" } }
   // { key: "anti-ghosting",   label: "Anti-Ghosting",     mode: "multi",  match: { startsWith: "Anti-Ghosting__" } }
    ],

    tagGroupSets: [
       {
        key: "layout",
        label: "Layout",
        children: ["layout", "length", "width", "height"]
      },
      {
        key: "design",
        label: "Design",
        children: ["colour", "wrist-rest", "weight"]
      },
      {
        key: "switches",
        label: "Switches",
        children: ["switch-type", "switches"]
      },
      {
        key: "keys",
        label: "Keys",
        children: ["keycaps", "key-rollover", "backlit", "macro-keys", "media-keys"]
      },
      {
        key: "connectivity",
        label: "Connectivity",
        children: ["wired-wireless", "compatibility", "connection", "cable-material", "cable-length", "usb-hub"]
      },
    ],
        valueOrder: {
        "tag.wrist-rest": ["Yes", "No"],
        "tag.layout": ["Full Size (UK)", "TenKeyLess (UK)", "TenKeyLess (US)", "75% (UK)", "75% (US)", "75% (US ISO)", "65% (UK)", "65% (US)", "60% (UK)", "60% (US)", "60%+Numpad (UK)"],
        "tag.switch-type": ["Linear", "Tactile", "Clicky", "Optical", "Membrane"],
        "tag.keycaps": ["PBT Double-Shot", "PBT", "ABS Double-shot"],
        "tag.backlit": ["RGB", "Single Colour LED", "No"],
        "tag.media-keys": ["Yes", "Yes (via F Keys)", "Yes (via Fn Keys)", "No"],
        "tag.key-rollover": ["Full Key", "104 Key", "24 Key", "19 Key", "10 Key"],
        "tag.macro-keys": ["Yes", "Fully programmable", "On the fly recording", "No"],
        "tag.usb-hub": ["Yes", "No"],
        "tag.compatibility": ["Windows", "Mac OS", "Linux"],
      }
  },
    "keycaps": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.compatibility", "tagset.design", "tag.keys"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "compatibility",   label: "Switches",        mode: "multi",  match: { startsWith: "Compatible with_" } },
      { key: "layout",          label: "Layout",          mode: "multi",  match: { startsWith: "Layout__" } },
      { key: "colour",          label: "Colour",          mode: "multi",  match: { startsWith: "F-Color_" } },
      { key: "material",        label: "Material",        mode: "multi",  match: { startsWith: "Material_" } },
      { key: "legends",         label: "Legends",         mode: "multi",  match: { startsWith: "Legend__" } },
      { key: "keys",            label: "No. of Keycaps",  mode: "multi",  match: { startsWith: "Total Keys__" } },
      { key: "backlit",         label: "Backlit",         mode: "multi",  match: { startsWith: "Backlit_" } }
    ],

    tagGroupSets: [
      {
        key: "compatibility",
        label: "Compatibility",
        children: ["layout", "compatibility"]
      },
      {
        key: "design",
        label: "Design & Build",
        children: ["colour", "material", "legends", "backlit"]
      },
    ],
        valueOrder: {
        "tag.layout": ["Universal", "UK", "US", "UK & US"],
        "tag.material": ["PBT", "ABS", "TPR Rubber", "Rubber"],
        "tag.legends": ["Double Shot", "Dye-Sublimated", "Translucent Cubic"],
        "tag.backlit": ["Yes", "Translucent", "No"],
      }
    },
    "wrist-rests": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.size", "tag.layout", "tag.base", "tag.base", "tag.weight"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor", "tagset.size", "tag.layout", "tag.base", "tag.base", "tag.weight"],

    tagGroups: [
      { key: "weight",          label: "Weight",          mode: "multi",  match: { startsWith: "P-Weight__" } },
      { key: "layout",          label: "Layout",          mode: "multi",  match: { startsWith: "Layout_" } },
      { key: "colour",          label: "Colour",          mode: "multi",  match: { startsWith: "F-Color_" } },
      { key: "base",            label: "Base",            mode: "multi",  match: { startsWith: "Base Material__" } },
      { key: "length",          label: "Length (mm)",     mode: "multi",  match: { startsWith: "Length_" } },
      { key: "width",           label: "Width (mm)",      mode: "multi",  match: { startsWith: "Width_" } },
      { key: "height",          label: "Height (mm)",     mode: "multi",  match: { startsWith: "Height_" } },
    ],

    tagGroupSets: [
      {
        key: "size",
        label: "Size",
        children: ["length", "width", "height"]
      },
    ],
        valueOrder: {
        "tag.layout": ["Full Size", "Tenkeyless", "75%", "60%", "Designed for Mice"],
      }
    },
    "cables": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tag.conn-1", "tag.conn-2", "tag.colour", "tag.length"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "conn-1",        label: "End #1",        mode: "multi",  match: { startsWith: "Connector #1__" } },
      { key: "conn-2",        label: "End #2",        mode: "multi",  match: { startsWith: "Connector #2__" } },
      { key: "colour",        label: "Colour",        mode: "multi",  match: { startsWith: "Colour__" } },
      { key: "length",        label: "Length",        mode: "multi",  match: { startsWith: "Cable Length__" } },

    ],
    },
    "shrouds": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tag.compatibility", "tag.material", "tag.colour"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor"],

    tagGroups: [
      { key: "compatibility",   label: "Compatible with", mode: "multi",  match: { startsWith: "Compatible with__" } },
      { key: "material",        label: "Material",        mode: "multi",  match: { startsWith: "Material_" } },
      { key: "colour",          label: "Colour",          mode: "multi",  match: { startsWith: "F-Color_" } }
    ],
    },
    "gaming-headsets-audio": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.headphones", "tagset.microphone", "tag.compatibility", "tagset.design", "tagset.connectivity"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor", "tagset.headphones", "tagset.microphone", "tag.compatibility", "tagset.design", "tagset.connectivity"],

    tagGroups: [
      { key: "wireless-range",                label: "Wireless Range (m)",     mode: "multi",   match: { startsWith: "Wireless Range__" } },
      { key: "wired-wireless",                label: "Wired/Wireless",         mode: "single",   match: { startsWith: "Wired/Wireless_" } },
      { key: "weight",                        label: "Weight (g)",             mode: "multi",   match: { startsWith: "P-Weight__" } },
      { key: "mic-type",                      label: "Type",                   mode: "multi",   match: { startsWith: "Mic Type__" } },
      { key: "mic-sensitivity",               label: "Sensitivity (dB)",       mode: "multi",   match: { startsWith: "F-Mic Sensitivity_" } },
    //{ key: "mic-impedance",                 label: "Impedance (Ohms)",            mode: "single",  match: { startsWith: "F-Mic Impedance_" } },
      { key: "mic-frequency-response",        label: "Frequency Response",     mode: "multi",  match: { startsWith: "Mic Frequency Response__" } },
      { key: "headset-sensitivity",           label: "Sensitivity (dB)",       mode: "multi",  match: { startsWith: "F-Headset Sensitivity_" } },
      { key: "headset-impedance",             label: "Impedance (Ohms)",       mode: "multi",  match: { startsWith: "F-Headset Impedance_" } },
      { key: "headset-frequency-response",    label: "Frequency Response",     mode: "multi",  match: { startsWith: "Headset Frequency Response__" } },
      { key: "compatibility",                 label: "Compatibility",          mode: "multi",  match: { startsWith: "F-Comp_" } },
      { key: "colour",                        label: "Colour",                 mode: "multi",  match: { startsWith: "F-Color_" } },
      { key: "audio-connection",              label: "Connection",             mode: "multi",  match: { startsWith: "F-Audio Connection_" } },
      { key: "drivers",                       label: "Drivers",                mode: "multi",  match: { startsWith: "Drivers__" } },
      { key: "cable-material",                label: "Cable Material",         mode: "multi",  match: { startsWith: "Cable Material__" } },
      { key: "cable-length",                  label: "Cable Length (m)",       mode: "multi",  match: { startsWith: "Cable Length__" } },
      { key: "battery-life",                  label: "Battery Life (Hrs)",     mode: "multi",  match: { startsWith: "F-Battery Life_" } },
      { key: "audio-type",                    label: "Audio Type",             mode: "multi",  match: { startsWith: "Audio Type_" } }
    ],

    tagGroupSets: [
      {
        key: "headphones",
        label: "Headphones",
        children: ["drivers", "audio-type", "headset-sensitivity", "headset-impedance", "headset-frequency-response"]
      },
      {
        key: "microphone",
        label: "Microphone",
        children: ["mic-type", "mic-sensitivity", "mic-impedance", "mic-frequency-response"]
      },
      {
        key: "design",
        label: "Design",
        children: ["colour", "weight"]
      },
      {
        key: "connectivity",
        label: "Connectivity",
        children: ["wired-wireless", "wireless-range", "battery-life", "audio-connection", "cable-material", "cable-length"]
      },
    ],
        valueOrder: {
        "tag.compatibility": ["PC", "Mac", "Playstation", "Xbox", "Switch", "Mobile", "iPad"],
        "tag.drivers": ["60mm", "53mm", "50mm", "40mm"],
        "tag.audio-type": ["7.1 Surround Sound", "THX Spatial", "360 Spatial", "Spatial Sound", "Hi-Res", "Windows Sonic", "Stereo"],
      }
    },
    "microphones": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.microphone", "tagset.headphones", "tagset.connectivity", "tagset.good-to-know" ],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor", "tagset.microphone", "tagset.headphones", "tagset.connectivity", "tagset.good-to-know"],

    tagGroups: [
      { key: "thd",                label: "THD",                  mode: "multi",   match: { startsWith: "THD__" } },
      { key: "sample-rate",        label: "Sample Rate",          mode: "multi",   match: { startsWith: "Sample Rate__" } },
      { key: "ratio",              label: "Ratio",                mode: "multi",   match: { startsWith: "Ratio__" } },
      { key: "power-output",       label: "Power Output",         mode: "multi",   match: { startsWith: "Power Output__" } },
      { key: "weight",             label: "Weight",               mode: "multi",   match: { startsWith: "P-Weight__" } },
      { key: "mic-type",           label: "Type",                 mode: "multi",   match: { startsWith: "Mic Type__" } },
      { key: "max-spl",            label: "Max SPL",              mode: "multi",   match: { startsWith: "Max SPL__" } },
      { key: "mic-sensitivity",    label: "Sensitivity",          mode: "multi",   match: { startsWith: "F-Mic Sensitivity_" } },
      { key: "mic-frequency",      label: "Frequency Response",   mode: "multi",   match: { startsWith: "Mic Frequency Response__" } },
      { key: "hp-impedance",       label: "Impedance",            mode: "multi",   match: { startsWith: "Headphone Impedance__" } },
      { key: "hp-frequency",       label: "Frequency Response",   mode: "multi",   match: { startsWith: "Headphone Frequency Response__" } },
      { key: "colour",             label: "Colour",               mode: "multi",   match: { startsWith: "F-Color_" } },
      { key: "capsules",           label: "Capsules",             mode: "multi",   match: { startsWith: "Capsules__" } },
      { key: "cable-material",     label: "Material",             mode: "multi",   match: { startsWith: "Cable Material__" } },
      { key: "cable-length",       label: "Length",               mode: "multi",   match: { startsWith: "Cable Length__" } },
      { key: "bit-rate",           label: "Bit Rate",             mode: "multi",   match: { startsWith: "Bit Rate__" } },
      { key: "connection",         label: "Connection",           mode: "multi",   match: { startsWith: "F-Audio Connection_" } },
      { key: "wired-wireless",     label: "Wired/Wireless",       mode: "single",  match: { startsWith: "Wired/Wireless_" } },
      { key: "compatibility",      label: "Compatible with",      mode: "multi",   match: { startsWith: "Compatible with_" } }
    ],

    tagGroupSets: [
      {
        key: "headphones",
        label: "Headphones",
        children: ["hp-impedance", "power-output", "thd", "hp-frequency", "headset-frequency-response"]
      },
      {
        key: "microphone",
        label: "Microphone",
        children: ["mic-type", "mic-frequency", "mic-sensitivity", "sample-rate", "bit-rate", "capsules", "max-spl", "ratio"]
      },
      {
        key: "good-to-know",
        label: "Good to know",
        children: ["compatibility", "weight"]
      },
      {
        key: "connectivity",
        label: "Connectivity",
        children: ["wired-wireless", "connection", "cable-material", "cable-length"]
      },
    ],
        valueOrder: {
        "tag.layout": ["Universal", "UK", "US", "UK & US"],
        "tag.material": ["PBT", "ABS", "TPR Rubber", "Rubber"],
        "tag.legends": ["Double Shot", "Dye-Sublimated", "Translucent Cubic"],
        "tag.sample-rate": ["48kHz", "96kHz", "192kHz"],
        "tag.power-output": ["5", "32"],
        "tag.compatibility": ["PC", "Mac"],
        "tag.backlit": ["Yes", "Translucent", "No"],
      }
    },
    "controllers": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.dimensions", "tagset.design", "tag.compatibility", "tagset.connectivity" ],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor", "tagset.dimensions", "tagset.design", "tag.compatibility", "tagset.connectivity" ],

    tagGroups: [
      { key: "wired-wireless",     label: "Wired/Wireless",       mode: "single",  match: { startsWith: "Wired/Wireless_" } },
      { key: "profiles",           label: "Profiles",             mode: "single",  match: { startsWith: "F-Profiles_" } },
      { key: "weight",             label: "Weight (g)",           mode: "multi",   match: { startsWith: "P-Weight__" } },
      { key: "compatibility",      label: "Compatibility",        mode: "multi",   match: { startsWith: "F-Comp_" } },
      { key: "mic-input",          label: "Mic Input",            mode: "multi",   match: { startsWith: "F-Mic Input_" } },
      { key: "lighting",           label: "Lighting",             mode: "multi",   match: { startsWith: "Lighting_" } },
      { key: "colour",             label: "Colour",               mode: "multi",   match: { startsWith: "F-Color_" } },
      { key: "length",             label: "Length",               mode: "multi",   match: { startsWith: "Length_" } },
      { key: "width",              label: "Width",                mode: "multi",   match: { startsWith: "Width_" } },
      { key: "height",             label: "Height",               mode: "multi",   match: { startsWith: "Height_" } },
      { key: "connection",         label: "Connection",           mode: "multi",   match: { startsWith: "F-Connection_" } },
      { key: "d-pad",              label: "D-Pad",                mode: "single",  match: { startsWith: "Circular D-pad__" } },
      { key: "cable-material",     label: "Material",             mode: "multi",   match: { startsWith: "Cable Material__" } },
      { key: "cable-length",       label: "Length (m)",           mode: "multi",   match: { startsWith: "Cable Length__" } },
      { key: "battery",            label: "Battery Life (Hrs)",   mode: "multi",   match: { startsWith: "F-Battery Life_" } },
      { key: "audio-conn",         label: "Audio Connection",     mode: "multi",   match: { startsWith: "F-Audio Connection_" } }
    ],

    tagGroupSets: [
      {
        key: "dimensions",
        label: "Dimensions",
        children: ["length", "width", "height"]
      },
      {
        key: "design",
        label: "Design & Build",
        children: ["hp-impedance", "colour", "d-pad", "profiles", "lighting", "weight"]
      },
      {
        key: "connectivity",
        label: "Connectivity",
        children: ["wired-wireless", "battery", "connection", "audio-conn", "mic-input", "cable-material", "cable-length"]
      },
    ],
        valueOrder: {
        "tag.d-pad": ["Yes", "No"],
        "tag.profiles": ["Yes", "No"],
        "tag.lighting": ["Yes", "No"],
        "tag.compatibility": ["PC", "Mac", "Playstation", "Xbox", "Switch", "Mobile", "iPad"],
      }
    },
    "earphones": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.earphones", "tagset.microphone", "tag.compatibility", "tagset.design", "tagset.connectivity"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor", "tagset.earphones", "tagset.microphone", "tag.compatibility", "tagset.design", "tagset.connectivity"],

    tagGroups: [
      { key: "wireless-range",                label: "Wireless Range (m)",       mode: "multi",    match: { startsWith: "Wireless Range__" } },
      { key: "wired-wireless",                label: "Wired/Wireless",           mode: "single",   match: { startsWith: "Wired/Wireless_" } },
      { key: "weight",                        label: "Weight (g)",               mode: "multi",    match: { startsWith: "P-Weight__" } },
      { key: "mic-type",                      label: "Type",                     mode: "multi",    match: { startsWith: "Mic Type__" } },
      { key: "mic-sensitivity",               label: "Sensitivity (dB)",         mode: "multi",    match: { startsWith: "F-Mic Sensitivity_" } },
      { key: "mic-impedance",                 label: "Impedance (Ohms)",         mode: "multi",    match: { startsWith: "F-Mic Impedance_" } },
      { key: "mic-frequency-response",        label: "Frequency Response",       mode: "multi",    match: { startsWith: "Mic Frequency Response__" } },
      { key: "headset-sensitivity",           label: "Sensitivity (dB)",         mode: "multi",    match: { startsWith: "F-Headset Sensitivity_" } },
      { key: "headset-impedance",             label: "Impedance (Ohms)",         mode: "multi",    match: { startsWith: "F-Headset Impedance_" } },
      { key: "headset-frequency-response",    label: "Frequency Response",       mode: "multi",    match: { startsWith: "Headset Frequency Response__" } },
      { key: "compatibility",                 label: "Compatibility",            mode: "multi",    match: { startsWith: "F-Comp_" } },
      { key: "colour",                        label: "Colour",                   mode: "multi",    match: { startsWith: "F-Color_" } },
      { key: "audio-connection",              label: "Connection",               mode: "multi",    match: { startsWith: "F-Audio Connection_" } },
      { key: "drivers",                       label: "Drivers",                  mode: "multi",    match: { startsWith: "Drivers__" } },
      { key: "cable-material",                label: "Cable Material",           mode: "multi",    match: { startsWith: "Cable Material__" } },
      { key: "cable-length",                  label: "Cable Length (m)",         mode: "multi",    match: { startsWith: "Cable Length__" } },
      { key: "battery-life",                  label: "Battery Life (Hrs)",       mode: "multi",    match: { startsWith: "F-Battery Life_" } },
      { key: "audio-type",                    label: "Audio Type",               mode: "multi",    match: { startsWith: "Audio Type_" } }
    ],

    tagGroupSets: [
      {
        key: "earphones",
        label: "Earbuds",
        children: ["drivers", "audio-type", "headset-sensitivity", "headset-impedance", "headset-frequency-response"]
      },
      {
        key: "microphone",
        label: "Microphone",
        children: ["mic-type", "mic-sensitivity", "mic-impedance", "mic-frequency-response"]
      },
      {
        key: "design",
        label: "Design",
        children: ["colour", "weight"]
      },
      {
        key: "connectivity",
        label: "Connectivity",
        children: ["wired-wireless", "wireless-range", "battery-life", "audio-connection", "cable-material", "cable-length"]
      },
    ],
        valueOrder: {
        "tag.compatibility": ["PC", "Mac", "Playstation", "Xbox", "Switch", "Mobile", "iPad"],
        "tag.drivers": ["60mm", "53mm", "50mm", "40mm"],
        "tag.audio-type": ["7.1 Surround Sound", "THX Spatial", "360 Spatial", "Spatial Sound", "Hi-Res", "Windows Sonic", "Stereo"],
      }
    },
    "headset-stands": {
    allow: ["filter.p.vendor", "filter.v.price", "filter.v.availability", "tagset.dimensions", "tagset.design", "tagset.connectivity"],
    order: ["filter.v.availability", "filter.v.price", "filter.p.vendor", "tagset.dimensions", "tagset.design", "tagset.connectivity"],

    tagGroups: [
      { key: "weight",          label: "Weight (g)",      mode: "multi",  match: { startsWith: "P-Weight__" } },
      { key: "colour",          label: "Colour",          mode: "multi",  match: { startsWith: "F-Color_" } },
   // { key: "compatibility",   label: "Compatibility",   mode: "multi",  match: { startsWith: "P-Comp__" } },
      { key: "lighting",        label: "Lighting",        mode: "single",  match: { startsWith: "Lighting_" } },
      { key: "length",          label: "Length",          mode: "multi",   match: { startsWith: "Length_" } },
      { key: "width",           label: "Width",           mode: "multi",   match: { startsWith: "Width_" } },
      { key: "height",          label: "Height",          mode: "multi",   match: { startsWith: "Height_" } },
      { key: "cable-material",  label: "Material",        mode: "multi",  match: { startsWith: "Cable Material__" } },
      { key: "cable-length",    label: "Length (m)",      mode: "multi",  match: { startsWith: "Cable Length__" } },
      { key: "audio-type",      label: "Audio Type",      mode: "multi",  match: { startsWith: "Audio Type__" } },
      { key: "audio-conn",      label: "Connection",      mode: "multi",  match: { startsWith: "Audio Connection_" } },
    ],

    tagGroupSets: [
      {
        key: "connectivity",
        label: "Connectivity",
        children: ["audio-type", "audio-conn", "cable-material", "cable-length"]
      },
      {
        key: "design",
        label: "Design & Build",
        children: ["colour", "lighting", "weight"]
      },
      {
        key: "dimensions",
        label: "Dimensions",
        children: ["length", "width", "height"]
      },
    ],
        valueOrder: {
        "tag.lighting": ["Yes", "No"],
      }
    }
  }
};

// Colour swatch map (label/handle -> CSS colour)
window.EG_COLOR_SWATCH_MAP = window.EG_COLOR_SWATCH_MAP || {
// Examples — use YOUR exact values as they appear in the UI
  "Black": "#000000",
  "White": "#ffffff",
  "Red": "#ff0000",
  "Blue": "#0000ff",
  "Gold": "#ffd700",
  "Green": "#008000",
  "Yellow": "#ffff00",
  "Orange": "#ffa500",
  "Pink": "#ffc0cb",
  "Purple": "#800080",
  "Grey": "#808080",
  "Brown": "#8b4513",
  "Teal": "#008080",
  "Ivory": "#FFFFF0",
  "Tan": "#d2b48c",
  "Neon": "#d9ff36",
  "Silver": "#c0c0c0",
  "Dark Blue": "#00008b",
  "Deep Blue": "#0006b1",
  "Amnis Blue": "#277CE0",
  "Blue Screen": "#0047bb",
  "Ice Blue": "#739BD0", 
  "Soft Blue": "#93CAED", 
  "Forest Green": "#228b22",
  "Green Screen": "#00b140",
  "Matcha Green": "#74A662",
  "Coffee Brown": "#6F4E37",
  "Wine Red": "#722F37",
  "Rich Red": "#E11218",
  "Daidai Orange": "#EE7800",
  "Camo":
  "linear-gradient(90deg, #604439, #9e9a75, #41533b)",
  "Multi-coloured":
  "linear-gradient(90deg, red, orange, yellow, green, blue, indigo, violet)",
};

// --- Smart (dynamic) collection header ---
// Set to false to freeze header content (keep Liquid header as-is).
// Flip back to true (or remove this line) later to re-enable.
window.EG_SMART_HEADER_ENABLED = false;

window.EG_URL_PRETTY = window.EG_URL_PRETTY || {
  // If true, tag handles like "surface-type__balanced" are written as "balanced"
  tagValueUseSuffix: true,

  // Optional: alias long Shopify facet params to short ones
  facetParamAliases: {
    "filter.v.availability": "in",
    "filter.p.vendor": "brand",
    "filter.p.product_type": "type",
    "filter.v.price.gte": "£min",
    "filter.v.price.lte": "£max"
  },

  // Optional: alias eg tag params to short ones (groupKey -> param name)
  // Example: surface_type group becomes ?st=balanced instead of ?eg_tag_surface_type=balanced
  tagParamAliases: {
    "surface_type": "glide",
    "surface_texture": "texture",
    "surface_material": "surface",
    "surface-coating": "coating",
    "base-material": "base",
    "firmness": "firmness",
    "stitched-edges": "stitch",
    "packaging-type": "package",
    "colour": "colour",
    "game-type": "game"
  }
};

// Filter value display renames (groupKey -> { from: to })
window.EG_FILTER_VALUE_RENAMES = window.EG_FILTER_VALUE_RENAMES || {
  "colour": {
    "Multi-coloured": "Multiple"
  },

  // Shopify facet: Brand/Vendor (filter.p.vendor)
  "filter.p.vendor": {
    "Tiger Gaming": "ESP Tiger",
    "Glorious PC Gaming Race": "Glorious"
  }
};

// Numeric tag slider groups (groupKey -> slider config)
window.EG_NUMERIC_TAG_SLIDERS = window.EG_NUMERIC_TAG_SLIDERS || {
  length:           { prefix: "Length_",                   param: "eg_range_length",             unit: "mm",    step: 1 },
  width:            { prefix: "Width_",                    param: "eg_range_width",              unit: "mm",    step: 1 },
  height:           { prefix: "Height_",                   param: "eg_range_height",             unit: "mm",    step: 1 },
  thickness:        { prefix: "Thickness_",                param: "eg_range_thickness",          unit: "mm",    step: 0.1 },
  area:             { prefix: "Area_",                     param: "eg_range_area",               unit: "cm²",   step: 1 },
  sleeve_length:    { prefix: "Sleeve-Length__",           param: "eg_range_sleeve_length",      unit: "cm",    step: 1 },
  cpi:              { prefix: "CPI/DPI__",                 param: "eg_range_cpi",                unit: "",      step: 50 },
  p_weight:         { prefix: "P-Weight__",                param: "eg_range_p_weight",           unit: "g",     step: 1 },
  p_buttons:        { prefix: "P-Buttons__",               param: "eg_range_p_buttons",          unit: "",      step: 1 },
  battery_life:     { prefix: "F-Battery Life_",           param: "eg_range_battery_life",       unit: "hrs",   step: 1 },
  range:            { prefix: "Wireless Range__",          param: "eg_range_range",              unit: "m",     step: 1 },
  cable_length:     { prefix: "Cable Length__",            param: "eg_range_cable_length",       unit: "m",     step: 0.1 },
  keys:             { prefix: "Total Keys__",              param: "eg_range_keys",               unit: "",      step: 1 },
  hp_sensitivity:   { prefix: "F-Headset Sensitivity_",    param: "eg_range_hp_sensitivity",     unit: "dB",    step: 1 },
  mic_sensitivity:  { prefix: "F-Mic Sensitivity_",         param: "eg_range_mic_sensitivity",   unit: "dB",    step: 1 }
};

